// Tamaño en píxeles de una caja, para que las gráficas SVG se dibujen a su tamaño real (letras
// nítidas y sin deformar, ocupando todo el hueco). null hasta medir o sin ResizeObserver (tests).
import { useEffect, useRef, useState } from 'react';

export function useTamano<T extends HTMLElement>(altoMin = 0) {
  const ref = useRef<T>(null);
  const [tam, setTam] = useState<{ ancho: number; alto: number } | null>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(([e]) => {
      if (!e) return;
      const { width, height } = e.contentRect;
      if (width > 0) setTam({ ancho: Math.round(width), alto: Math.max(altoMin, Math.round(height)) });
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [altoMin]);
  return [ref, tam] as const;
}
